/* Trafford shared scroll-reveal. Adds .is-in to [data-twc-reveal] elements as they
   enter the viewport (once each). Reduced-motion + no-IO fallbacks show everything.
   Re-scans on Shopify section load so the theme editor previews correctly. */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function showAll(scope) {
    (scope || document).querySelectorAll('[data-twc-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function observe(scope) {
    var els = (scope || document).querySelectorAll('[data-twc-reveal]:not(.is-in)');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) { showAll(scope); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') observe();
  else document.addEventListener('DOMContentLoaded', function () { observe(); });

  // Shopify theme editor: re-scan a section when it is (re)rendered.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
